import CommonIconButton from "@/modules/common/components/ui-kit/buttons/icon-button";
import MaximizeIcon from "@/modules/common/components/ui-kit/icons/maximize-icon";
import MinimizeIcon from "@/modules/common/components/ui-kit/icons/minimize-icon";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import FilterMenu from "@/modules/lead-page/new/components/activity/filters/filter-menu";
import MobileFilterMenu from "@/modules/lead-page/new/components/activity/filters/mobile-filter-menu";
import useFilterMenuItems from "@/modules/lead-page/new/hooks/filter-menu-items.hook";
import { Stack, useTheme } from "@mui/material";
import { useCallback } from "react";

interface ActivityFiltersProps {
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

const ActivityFilters = ({
  collapsed,
  onToggleCollapse,
}: ActivityFiltersProps) => {
  const theme = useTheme();

  const { isMobile } = useScreenSize();

  const { filters } = useFilterMenuItems();

  const renderFilterMenu = useCallback(() => {
    if (isMobile) {
      return <MobileFilterMenu />;
    }

    return filters.map((filter, index) => (
      <FilterMenu
        key={`${filter.buttonText}-${index}`}
        buttonText={filter.buttonText}
        menuItems={filter.menuItems}
        anchorOrigin={filter.anchorOrigin}
        transformOrigin={filter.transformOrigin}
      />
    ));
  }, [isMobile, filters]);

  return (
    <Stack direction="row" alignItems="center" gap={theme.nawy.spacing.xs}>
      {isMobile && (
        <CommonIconButton
          variant="outlined-secondary"
          size="md"
          onClick={onToggleCollapse}
        >
          {collapsed ? <MinimizeIcon /> : <MaximizeIcon />}
        </CommonIconButton>
      )}
      {renderFilterMenu()}
    </Stack>
  );
};

export default ActivityFilters;
